import React from 'react'
import './SingleSmallImg.css'
function SingleSmallImg({img}) {
    const unavailable =
  "https://www.movienewz.com/img/films/poster-holder.jpg";
  return (
    <div className='singleSmallImg'>
      <img className="singleSmallImg_Img" src={img?img:unavailable} alt="" />
    </div>
  )
}

export default SingleSmallImg
